import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
// material
import { Box, Grid, Card, Button, Typography, Stack } from "@mui/material";
import { PATH_DASHBOARD } from "../../../routes/paths";
import { fCurrency, fNumber } from "../../../utils/formatNumber";
import { ShowError } from "../../../utils/loader";
import { CheckPerm } from "../../../utils/apis";
// ----------------------------------------------------------------------

SingleCard.propTypes = {
  product: PropTypes.object,
};

function SingleCard({ product }) {
  const { name, sellingPrice, qty, pid } = product;
  return (
    <Card
      variant="outlined"
      sx={{
        border: "0.4px solid",
        borderColor: "background.border",
        boxShadow:
          "4px 2px 124px rgba(46, 53, 58, 0.02), 0px 4px 124px rgba(46, 41, 78, 0.02)",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        p: 3,
      }}
    >
      <Box sx={{ flexGrow: 1, minWidth: 0, pl: 2, pr: 1 }}>
        <Typography variant="subtitle2" noWrap>
          {name}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            Quantity Left: {fNumber(qty)}
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
          Selling Price: {fCurrency(sellingPrice)}
        </Typography>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          sx={{ mt: 2 }}
          component={RouterLink}
          to={`${PATH_DASHBOARD.subpages.product}/${pid}`}
        >
          View
        </Button>
      </Box>
    </Card>
  );
}

Products.propTypes = {
  products: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
};

export default function Products({ products, type }) {
  const hasPermission = CheckPerm("view_products");
  return (
    <Box sx={{ mt: 5 }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: { md: 3, xs: 2 } }}
      >
        <Typography variant="h4">Products</Typography>
        {hasPermission && (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            component={RouterLink}
            to={PATH_DASHBOARD.business.products}
          >
            View All
          </Button>
        )}
      </Stack>
      {products.length > 0 ? (
        <Grid container spacing={3}>
          {products.map((product, index) => (
            <Grid key={index} item xs={12} md={4}>
              <SingleCard product={product} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <ShowError
          message={
            new Error(
              `This ${type} does not have any product attached at the moment!`
            )
          }
        />
      )}
    </Box>
  );
}
